module.exports = __webpack_public_path__ + "media/npc_dota_hero_nyx_assassin.c423fe1d.webm";